import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { RequestsService } from '../../_shared/services/requests.service'
import { FormGroup, Validators, FormControl } from '@angular/forms'
import { AuthenticationService } from '../../_services/authentication.service'
import { HelperFunctions } from '../../_shared/utils/helper-functions'

declare var jQuery: any

@Component({
  selector: 'app-edit-diagnosis-modal',
  templateUrl: './edit-diagnosis-modal.component.html',
  styleUrls: ['./edit-diagnosis-modal.component.scss'],
})
export class EditDiagnosisModalComponent implements OnInit {
  constructor(
    private api: RequestsService,
    private helperFunctions: HelperFunctions,
    private authenticationService: AuthenticationService
  ) {}

  @Input() diagnosisId
  @Input() diagnosisInput
  @Input() diagnosisData
  @Input() category
  @Input() modalId
  @Input() action

  @Output() closeDiagnosisModalEvent = new EventEmitter()
  @Output() refreshDiagnosisEvent = new EventEmitter()

  // diagnosisInformationForm: FormGroup;
  form: FormGroup

  diagnosisInformation: object
  updatedDiagnosisInformation: object
  loading: boolean = false
  editDiagnosticInformationLoading: boolean = false
  message: string
  selectedInputName: string
  selectedInputId: string
  selectedInfo: object[] = []
  country_id: string
  countryName: string
  recommendInput: object
  submitted: boolean
  searchItem: string
  crops: any
  inputs: any
  filterInputs: any
  file: any
  parts: any
  selectedImage: File = null
  changeImage(event) {
    this.selectedImage = <File>event.target.files[0]
  }
  status: string

  // Quill editor config
  quillConfig = {
    toolbar: [
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.countryName = country

    if (this.countryName === 'Uganda') {
      this.parts = [
        'Spraying',
        'Soil testing',
        'Tractor hire',
        'Garden mapping',
      ]
    } else if (this.countryName === 'India') {
      this.parts = ['Garden mapping']
    }

    this.loadDiagnosisInformation(this.diagnosisData)
    this.getInputs()
    this.loadCrops()
  }

  getInputs() {
    this.loading = true
    this.api
      .dash_get(`mobile/input/${this.countryName}`, null)
      .subscribe((res) => {
        this.loading = false
        this.inputs = res.data
        this.filterInputs = res.data
      })
  }

  filterFunction() {
    this.searchItem = jQuery('#searchBox').val()
    console.log(this.inputs)
    this.filterInputs = this.inputs.filter(
      (input) =>
        input.name.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
    // console.log(this.searchItem);
  }

  // initializeDiagnosisForm(diagnosisInformation: any) {
  //   this.diagnosisInformationForm = new FormGroup({
  //     'name': new FormControl(diagnosisInformation.name, [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
  //     'cause': new FormControl(diagnosisInformation.cause, [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
  //     'crop': new FormControl(diagnosisInformation.crop, [Validators.required, Validators.pattern('[a-zA-Z ]*')]),
  //     'photo': new FormControl(null),
  //     'control': new FormControl(diagnosisInformation.control),
  //     'explanation': new FormControl(diagnosisInformation.explanation)
  //   });
  // }

  // get name() { return this.diagnosisInformationForm.get('name'); }

  // get cause() { return this.diagnosisInformationForm.get('cause'); }

  retrieveInputName(inputId: string) {
    this.loading = true
    this.api.dash_get(`mobile/input/${inputId}`, null).subscribe((res) => {
      this.loading = false
      this.selectedInputName = res.data
      // this.recommendInput = {id:inputId,name:this.selectedInputName};
      this.selectedInfo.push({ id: inputId, name: this.selectedInputName })
    })
  }

  loadDiagnosisInformation(data: object): void {
    this.diagnosisInformation = data
    console.log(this.diagnosisInput)
    if (this.diagnosisInput != undefined) {
      this.diagnosisInput.map((element) => {
        this.retrieveInputName(element.value)
      })
    }
    // this.api.getData(`diagnosis/${this.category}/${id}`).subscribe(
    //   res => {
    //     this.loading = false;

    //     this.initializeDiagnosisForm(this.diagnosisInformation);
    //   },
    //   err => {
    //     this.loading = false;
    //     this.message = err.error;
    //   }
    // );
  }

  loadCrops(): void {
    this.api
      .dash_get(`enterprises/${this.countryName}`, null)
      .subscribe((res) => {
        this.crops = res
      })
  }

  closeEditDiagnosisModal() {
    this.closeDiagnosisModalEvent.emit()
  }

  refreshDiagnosisInformation() {
    this.refreshDiagnosisEvent.emit()
  }

  // processPhoto(event) {
  //   if(event.target.files.length > 0) {
  //     const file = event.target.files[0];
  //     if ((/\.(jpg|jpeg|png)$/i).test(file.name) && file.size <= 2000000) {
  //       this.diagnosisInformationForm.controls['photo'].setErrors(null);
  //       this.file = file;
  //     } else {
  //       this.diagnosisInformationForm.controls['photo'].setErrors({'invalid': true});
  //     }
  //   }
  // }

  // onSubmit() {
  //   this.submitted = true;
  //   if (this.diagnosisInformationForm.valid) {
  //     const { value } = this.diagnosisInformationForm;
  //     value['photo'] === null ? delete value['photo'] : null;
  //     let formData = new FormData();
  //     Object.keys(value).forEach(inputKey => {
  //       if (inputKey == 'photo' && this.file){
  //         formData.append(inputKey, this.file);
  //       } else {
  //         formData.append(inputKey, value[inputKey]);
  //       }
  //     });
  //     this.editDiagnosisInformation(formData);
  //   }
  //   return;
  // }

  updateDiagnosis(updateDiagnosisForm) {
    this.loading = true
    const form = updateDiagnosisForm
    let formData = new FormData()

    formData.append('name', form.name)
    formData.append('control', form.control)
    formData.append('explanation', form.explanation)
    formData.append('crop', form.crop)
    formData.append('input', form.input)
    formData.append('cause', form.cause)
    formData.append('service', form.service)
    if (this.selectedImage)
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    this.api
      .dash_putWithImage(
        `diagnosis-update/${this.category}/${this.diagnosisId}`,
        formData
      )
      .subscribe(
        (response) => {
          this.message = response.message
          this.refreshDiagnosisInformation()
          this.status = 'Success'
          this.loading = false
          // this.message = `${this.helperFunctions.capitalize(this.category)} info has been successfully edited`;
        },
        (error) => {
          this.editDiagnosticInformationLoading = false
          this.status = 'Failure'
          this.message = 'An error occurred. Please try again'
        }
      )
  }

  // editDiagnosisInformation(newDiagnosisInformation: object) {
  //   this.editDiagnosticInformationLoading = true;
  //   this.api.postData(`diagnosis/${this.category}/${this.diagnosisId}`, newDiagnosisInformation).subscribe(
  //     res => {
  //       this.editDiagnosticInformationLoading = false;
  //       this.updatedDiagnosisInformation = res.data[0];
  //       this.refreshDiagnosisInformation();
  //       this.status = 'Success';
  //       this.message = `${this.helperFunctions.capitalize(this.category)} info has been successfully edited`;
  //     },
  //     err => {
  //       this.editDiagnosticInformationLoading = false;
  //       this.status = 'Failure';
  //       this.message = 'An error occurred. Please try again';
  //     }
  //   );
  // }

  resetUpdateModal() {
    jQuery('#editModal').modal('hide')
    this.status = null
    this.message = null
    this.selectedImage = <File>null
    console.log(this.selectedImage)
  }
}
